export default __webpack_public_path__ + "static/media/email-transparent-icon-4.a5650791.png";